import React from "react";

import {
  IgButton,
  IgDivider,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { useDisableIntegration } from "../../../../api/integrations/disable-integration";
import { usePutIntegration } from "../../../../api/integrations/put-integration";
import { IgAlertSimple } from "../../../../components/Utils/IgAlertSimple";
import { GreenCheckIcon } from "../../../../images/Icons/GreenCheckIcon";

interface ClarityIntegrationProps {
  clarityIntegration?: BaseIntegrationDto;
}

export const ClarityIntegration = ({
  clarityIntegration,
}: ClarityIntegrationProps) => {
  const putIntegration = usePutIntegration();
  const disableIntegration = useDisableIntegration();

  const onEnableClick = (action: "new" | "delete") => {
    if (action === "new") {
      putIntegration.mutate({
        body: {
          name: "Clarity",
        },
        pathParams: undefined,
        queryParams: undefined,
      });
    } else if (clarityIntegration?.id) {
      disableIntegration.mutate({
        body: undefined,
        pathParams: {
          id: clarityIntegration?.id,
        },
        queryParams: undefined,
      });
    }
  };

  return (
    <IgPaper sx={{ border: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container alignItems={"center"}>
            {clarityIntegration?.enabled ? (
              <Grid item sx={{ marginRight: "15px", marginTop: "6px" }}>
                <GreenCheckIcon />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                sx={{
                  lineHeight: "26px",
                  letterSpacing: "0.5px",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Microsoft Clarity
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgButton
            variant={"contained"}
            loading={putIntegration.isPending || disableIntegration.isPending}
            onClick={() =>
              onEnableClick(clarityIntegration?.enabled ? "delete" : "new")
            }
          >
            {clarityIntegration?.enabled ? "Disable" : "Enable"}
          </IgButton>
        </Grid>
        {/*{clarityIntegration && clarityIntegration?.enabled ? (*/}
        {/*  <Grid container item direction={"column"}>*/}
        {/*    <Grid item>*/}
        {/*      <IgDivider spacing={"s"} />*/}
        {/*    </Grid>*/}
        {/*    <Grid container item alignItems={"center"} columnSpacing={2}>*/}
        {/*      <IgAlertSimple*/}
        {/*        severity={"warning"}*/}
        {/*        message={*/}
        {/*          <IgTypography>*/}
        {/*            <IgTypography sx={{ fontWeight: 600 }}>*/}
        {/*              Previously Integrated Clarity using our docs?*/}
        {/*            </IgTypography>*/}
        {/*            <IgTypography>*/}
        {/*              {" "}*/}
        {/*              Be sure to remove the script from your website to avoid*/}
        {/*              double-tagging events.*/}
        {/*            </IgTypography>*/}
        {/*          </IgTypography>*/}
        {/*        }*/}
        {/*        alertKey={`clarity-warning`}*/}
        {/*      />*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*) : null}*/}
      </Grid>
    </IgPaper>
  );
};
